import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {default as TimeOffSummaryWidget} from "./TimeOffSummaryWidget"
import * as unavailableDatesActions from '../redux/timeoff_request_modal_actions';
import * as supervisorActions from '../redux/supervisor_time_off_actions';
import * as actions from '../redux/time_off_actions';
import {LeftRequestItem, RightRequestItem, ApprovalButton} from './TimeOffDetail'

export class PendingTab extends Component {
    constructor(props) {
		super(props);        
        
        this.state = {
            unavailableDates: [],
            ManagementUnitID: props.ManagementUnitID,
            FilteredRequests: [],
            isRefreshNeeded: props.isRefreshNeeded ? props.isRefreshNeeded : false
        }

        if(this.props.actions.fetchUnavailabledDatesAction && props.ManagementUnitID > -1 ) {
            this.props.actions.fetchUnavailabledDatesAction({managementUnitID: props.ManagementUnitID});
        }

        this.approveClicked = this.approveClicked.bind(this)
        this.denyClicked = this.denyClicked.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.unavailableDates !== nextProps.unavailableDates) {
            this.setState({
                unavailableDates: nextProps.unavailableDates
            })
        }

        if(this.props.ManagementUnitID !== nextProps.ManagementUnitID) {
            this.setState({
                ManagementUnitID: nextProps.ManagementUnitID
            })

            if(nextProps.ManagementUnitID > -1) {
                this.props.actions.fetchUnavailabledDatesAction({managementUnitID: nextProps.ManagementUnitID});
            }
            else {
                this.setState({
                    unavailableDates: []
                })
            }
        }

		let currReqs = JSON.stringify(this.props.FilteredRequests);
        let nextReqs = JSON.stringify(nextProps.FilteredRequests);
        
        if (currReqs !== nextReqs) {
            this.setState({
                FilteredRequests: nextProps.FilteredRequests
            })
        }

        if((nextProps.patchTimeOffResponse && this.state.isRefreshNeeded) || (nextProps.isRefreshNeeded && this.props.ManagementUnitID === nextProps.ManagementUnitID)) {
            var requestParameters = {
                Page: 1,
                PageSize: 9999,
                SortOrder: 'desc',
                SortColumn: 'DateCreated',
                customFilters: [
                    { "PropertyName": "ManagementUnitID", "Operation": 1, "Value": this.state.ManagementUnitID },
                    { "PropertyName": "RequestStatus", "Operation": 1, "Value": 0 }
                ]
            }
            this.props.actions.fetchCurrentRequestsAction(requestParameters);
            this.props.actions.fetchUnavailabledDatesAction({managementUnitID: nextProps.ManagementUnitID});
            this.setState({isRefreshNeeded: false})            
        }
    }

    approveClicked(id) {      

        var timeOffRequest = {
            timeoffRequestId: id,
            requestStatus: 1,
            supervisorId: this.props.User.userID //Approved
        }

        if(this.props.actions.patchTimeOffRequestAction) {
            this.props.actions.patchTimeOffRequestAction(timeOffRequest)                
            this.setState({isRefreshNeeded: true})
        }
    }

    denyClicked(id) {
        var timeOffRequest = {
            timeoffRequestId: id,
            requestStatus: 2 //Denied
        }
        
        if(this.props.actions.patchTimeOffRequestAction) {
            this.props.actions.patchTimeOffRequestAction(timeOffRequest)
            this.setState({isRefreshNeeded: true})
        }
    }
    
    render() {
        let items = []
        let{User, position} = this.props;
        this.state.FilteredRequests.forEach((item, index) => {
                if(User.position === position["superVisorReadOnly"])
                       items.push(
                       <div key={index} className="request-container">
                            <LeftRequestItem item={item} />
                            <RightRequestItem item={item} />                            
                        </div>)
                else
                    items.push(
                        <div key={index} className="request-container">
                            <LeftRequestItem item={item} />
                            <RightRequestItem item={item} />
                            <ApprovalButton 
                                requestID={item.id} 
                                onClick={this.approveClicked}
                                denyClicked={this.denyClicked} /> 
                        </div>)
                            })
              
                        
            
        if(items.length === 0) {
            items = <div className="empty-container">
                        <span className="empty-container-text">
                            No pending time off requests.
                        </span>
                    </div>
        }

        return (
            <div>
                <div className="left-side-container custom-scroll-bar">
                    <div className="status-container-title">
                        Pending Requests
                    </div>
                    <div className="line"></div>
                        
                        {items}

                </div>
                <div className="right-side-container">
                    <TimeOffSummaryWidget 
                        unavailableDates={this.state.unavailableDates}
                        managementUnitID={this.state.ManagementUnitID}
                        isRefreshNeeded = {this.state.isRefreshNeeded}/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        User: state.common.user,
        position: state.common.position,  		        
		unavailableDates: state.timeoff.unavailableDates,
        FilteredRequests: state.timeoff.FilteredRequests,
        patchTimeOffResponse: state.timeoff.patchTimeOffResponse
        
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...unavailableDatesActions, ...supervisorActions}, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps 
)(PendingTab);



// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/PendingTab.js